/** Matches backend `promotion.condition.type.js` */
const PromotionConditionType = {
  DISCOUNT: 0,
  CONDITIONAL: 1,
  COMBINED: 2,
  PROMO_CODE: 3,
}

export default PromotionConditionType
